// extracted by mini-css-extract-plugin
export var body = "styles-mod--body--1083f";
export var button = "styles-mod--button--570f6";
export var formInner = "styles-mod--form-inner--26304";
export var links = "styles-mod--links--dad73";
export var loginInfo = "styles-mod--login-info--779ba";
export var opened = "styles-mod--opened--9a9d1";
export var showPasswordIcon = "styles-mod--show-password-icon--10810";
export var sidePanel = "styles-mod--side-panel--e34a1";
export var subtitle = "styles-mod--subtitle--83394";